import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { trackMetrikaPageView } from '../../utils/metrika';

const MetrikaPageViews = () => {
  const { pathname, search, hash } = useLocation();
  const previousUrl = useRef<string | null>(null);
  useEffect(() => {
    const url = `${window.location.origin}${pathname}${search}${hash}`;
    if (previousUrl.current === url) return;
    if (trackMetrikaPageView(url, previousUrl.current ?? document.referrer)) previousUrl.current = url;
  }, [pathname, search, hash]);
  return null;
};

export default MetrikaPageViews;
